module.exports = __webpack_public_path__ + "static/media/smart cities.30465385.jpeg";